import { render, staticRenderFns } from "./ActivateForm.vue?vue&type=template&id=34172b3a&"
import script from "./ActivateForm.vue?vue&type=script&lang=js&"
export * from "./ActivateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports